import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { fromEvent, Observable, of, ReplaySubject } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    map,
    shareReplay,
} from 'rxjs/operators';
import { WINDOW } from './window.service';

export interface WindowSize {
    innerHeight: number;
    innerWidth: number;
    ratio: number;
    isDesktop: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class DeviceService {
    private resize: Observable<Event>;
    windowSize: ReplaySubject<WindowSize>;
    breakPointSwitch: Observable<WindowSize>;
    breakPoint = 768;
    isDesktop: Observable<boolean>;

    constructor(
        @Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        if (isPlatformBrowser(platformId)) {
            this.resize = fromEvent(this.window, 'resize');
        } else {
            this.resize = of(null);
        }
        this.windowSize = new ReplaySubject(1);
        this.windowSize.next(this.calculateWindowSizes());
        this.resize
            .pipe(
                debounceTime(100),
                map(event => this.calculateWindowSizes())
            )
            .subscribe(this.windowSize);
        this.breakPointSwitch = this.windowSize.pipe(
            distinctUntilChanged(
                (x: WindowSize, y: WindowSize) => x.isDesktop === y.isDesktop
            )
        );

        this.isDesktop = this.windowSize.pipe(
            map(size => size.isDesktop),
            distinctUntilChanged(),
            shareReplay(1)
        );
    }

    calculateWindowSizes(): WindowSize {
        if (isPlatformBrowser(this.platformId)) {
            return this.calculateWindowParams(
                this.window.innerWidth,
                this.window.innerHeight
            );
        } else {
            //smallest supported screen
            return this.calculateWindowParams(375, 559);
        }
    }
    calculateWindowParams(width: number, height: number): WindowSize {
        return {
            innerHeight: height,
            innerWidth: width,
            ratio: width / height,
            isDesktop: width >= this.breakPoint,
        };
    }
}
